
import { isBayer } from '@/utils';
import { WrapperImage, WrapperPattern } from './styles';

export default {
  name: 'BackgroundImage',
  components: {
    WrapperImage,
    WrapperPattern,
  },
  props: {},
  data() {
    return {
      image: isBayer() ? 'bayer' : 'regenera',
    };
  },
};
